import { render, staticRenderFns } from "./customer-role-select.vue?vue&type=template&id=af4ce47c&scoped=true&"
import script from "./customer-role-select.vue?vue&type=script&lang=js&"
export * from "./customer-role-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4ce47c",
  null
  
)

export default component.exports